import { Container, Graphics } from 'pixi.js';

export class ShadowLayer {
  readonly container: Container;
  private gfx: Graphics;

  constructor() {
    this.container = new Container();
    this.gfx = new Graphics();
    this.container.addChild(this.gfx);
    this.container.alpha = 0.25;
  }

  update(radius: number): void {
    const g = this.gfx;
    g.clear();
    g.circle(2, 2, radius);
    g.fill({ color: 0x000000, alpha: 0.3 });
  }

  setVisible(visible: boolean): void {
    this.container.visible = visible;
  }

  destroy(): void {
    this.gfx.clear();
    this.gfx.destroy();
    this.container.removeChildren();
  }
}
